import React, { useState, useEffect, useMemo, useRef } from 'react'
import { LOADER_TIME, showFilterlist, SOCKET_EVENTS, REQUEST_SLUGS } from '../../utils/Constants';
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import StatusFilter from '../../components/company_panel/common/statusFilter';
import Sorting from '../../components/company_panel/common/sorting';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ChangeStatusLoyaltyPoint, ListLoyaltyPoints } from '../../services/company_panel/loyaltypoints.service';
import Loader from '../../components/company_panel/common/loader';
import { capitalizeFirstLetter, checkPermission, formateDate, getBrandId, getCompany, getOutletBusinessDate, getOutletId, isOnline, isOutletBusinessDay, removeHyphens, showPrice, getExcelColumnWidths } from '../../helpers/commonFunctions';
import Swal from 'sweetalert2';
import notFound from '../../assets/company/img/no-record-found.png'
import { createDummyOrdersForCompany, DeletePendingOrder, ExportOrdersList, forceOrderClose, GetOrdersList, GetSingleOrderDetails, RefundStatus, reportToZatcaAgain } from '../../services/company_panel/orderService';
import { renderReceiptCanvas, canvasToPdf } from '../../helpers/receiptTemplate';
import { GetCustomerInvoice } from '../../services/company_panel/setting/invoiceServices';
import CustomPagination from '../../components/company_panel/common/custompagination';
import { GetActiveOrderModes } from '../../services/company_panel/setting/orderModeConfigurationService';
import { GetOutletAllList, GetBrandOutletsList } from '../../services/company_panel/outletService';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { AllRefundReasons, getRefundConfiguration } from '../../services/company_panel/refund.services';
import { SOCKET_CLIENT } from '../../utils/socket';
import { countries } from 'countries-list';
import { getAllOrders } from '../../helpers/indexedDB';
import QRCode from "react-qr-code";
import { Modal, Button, Form } from 'react-bootstrap';
import GlobalLoader from '../../components/company_panel/common/globalLoader';
import { usePersistedListState } from '../../hooks/usePersistedListState';

const RefundOrder = () => {
    // const navigator = useNavigate();
    const params = useParams()
    const location = useLocation()
    // persisted filters (page lives in the route) — restored on return from view
    const { saved, save, clear } = usePersistedListState('orders');
    const [search, setSearch] = useState(saved?.search || {})
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "");
    const [resetdate, setResetDate] = useState(false)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [invoicePreview, setInvoicePreview] = useState({ open: false, image: '', order: null });
    const invoiceCanvasRef = useRef(null);
    // When we cancel an order locally we show the API-response toast, so suppress the
    // duplicate toast from the cancel-order socket event. Reset after the API responds.
    const suppressCancelToastRef = useRef(false);
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [showRefundModal, setShowRefundModal] = useState(false);
    const [refundOrderId, setRefundOrderId] = useState(null);
    const [refundReason, setRefundReason] = useState('');
    const [refundReasonText, setRefundReasonText] = useState('');
    const navigate = useNavigate();
    const [orderListData, setOrderListData] = useState([]);
    const [orderModeData, setOrderModesData] = useState([]);
    const [selectedOrderMode, setSelectedOrderMode] = useState(saved?.search?.order_mode_id || '');
    const [selectedOrderStatus, setSelectedOrderStatus] = useState(saved?.search?.order_status || '');
    const [selectedTransactionType, setSelectedTransactionType] = useState(saved?.search?.transaction_type || '');
    const [selectedZatcaStatus, setSelectedZatcaStatus] = useState(saved?.search?.zatca_status || '');
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(saved?.search?.payment_status || '');
    const [error, setError] = useState('');
    const [refundConfiguration, setRefundConfiguration] = useState([]);
    const [allRefundReasons, setAllRefundReasons] = useState([]);
    const [newOrder, setNewOrder] = useState(false)

    // const [refundEndTime, setRefundEndTime] = useState([]);
    // const [currentTime, setCurrentTime] = useState(new Date());
    const [showZatcaDetailsModel, setShowZatcaDetailsModel] = useState(false);
    const [loaderNew, setLoaderNew] = useState(false)
    const [zatcaModelData, setZatcaModelData] = useState([]);

    const companyUser = JSON.parse(localStorage.getItem("company_user"))
    // useEffect(() => {
    //     // Update currentTime every second
    //     const intervalId = setInterval(() => {
    //         setCurrentTime(new Date());
    //     }, 1000);

    //     // Cleanup the interval on component unmount
    //     return () => clearInterval(intervalId);
    // }, []);

    // useEffect(() => {
    //     if (orderListData.length) {
    //         getRefundConfiguration({ brand_id: getBrandId() }).then(data => {
    //             setRefundConfiguration(data && data.data && data.data.response ? data.data.response : []);

    //             let refundTime = {};
    //             data?.data?.response?.forEach((configuration) => {
    //                 if (configuration.type == 'order_mode') {
    //                     refundTime[configuration.order_mode_id] = configuration.time;
    //                 }
    //             })

    //             let times = [];
    //             orderListData.forEach((order, index) => {
    //                 const refundTimeMinutes = refundTime[order.order_mode_id] || 0;
    //                 const createdDate = new Date(order.transaction.created_at);
    //                 const validDate = new Date(createdDate.getTime() + (refundTimeMinutes * 60000));
    //                 times.push(validDate);
    //             })
    //             setRefundEndTime(times);


    //         }).catch(error => {
    //             console.log("error=====>", error);
    //         });
    //     }
    // }, [orderListData])


    // const isRefundValid = (order) => {
    //     const configuration = refundConfiguration.filter(
    //         configuration => configuration.type == 'order_mode' && configuration.order_mode_id == order.order_mode_id
    //     );
    //     if (!configuration[0]) {
    //         return false;
    //     }
    //     const refundTimeMinutes = configuration[0].time;
    //     const createdDate = new Date(order.transaction.created_at);
    //     const validDate = new Date(createdDate.getTime() + (refundTimeMinutes * 60000));
    //     const currentDate = new Date();
    //     if (currentDate <= validDate) {
    //         return true;
    //     }
    //     return false;
    // }

    // const getRemainingRefundTime=(row)=>{
    //     if(row.transaction.payment_status != 'paid'){
    //         return 0;
    //     }
    //     const configuration = refundConfiguration.filter(
    //         configuration => configuration.type == 'order_mode' && configuration.order_mode_id == row.order_mode_id
    //     );
    //     if(!configuration[0]){
    //         return false;
    //     }
    //     const refundTimeMinutes = configuration[0].time;   
    //     const createdDate = new Date(row.created_at);
    //     const validDate = new Date(createdDate.getTime() + (refundTimeMinutes * 60000));
    //     const currentDate = new Date();
    //     let remainingMinutes = 0;
    //     if(validDate > currentDate){
    //         remainingMinutes = (validDate.getTime() - currentDate.getTime())/60000;
    //     }
    //     console.log('---------remaining', remainingMinutes);
    //     return remainingMinutes;
    // }
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    // const [dummyOrdersCount, setDummyOrdersCount] = useState(10);
    // const currentDateDefault = true;

    const businessDate =  getOutletBusinessDate();
    const start_date = new Date(businessDate.setHours(0,0,0,0));
    const end_date = new Date(businessDate.setHours(23,59,59,999));
    // console.log(businessDate);
    // if we're returning with a persisted date filter, show that range in the picker
    // instead of the default business date (records already restore from saved.search)
    const [defaultDateFilter, setDefaultDateFilter] = useState(
        saved?.search?.created
            ? [new Date(saved.search.created.start), new Date(saved.search.created.end)]
            : [start_date, end_date]
    );
    const defaultDateFilterRef = useRef({
        start_date,
        end_date
    });


    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setSearch(prev => { const { created, ...rest } = prev || {}; return rest; });

            const businessDate =  getOutletBusinessDate();
            const start_date = new Date(businessDate.setHours(0,0,0,0));
            const end_date = new Date(businessDate.setHours(23,59,59,999));
            setDefaultDateFilter([
                start_date,
                end_date
            ])
            defaultDateFilterRef.current = {
                start_date,
                end_date
            }
            
            setIsOutletChanged(!isOutletChanged);
        });
    });

    // console.log(defaultDateFilterRef.current, '====default date filter');

    useEffect(() => {
        if (search && isOnline()) {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData()

                let modifiedSearchFilter= search;
                if(!search || !search.created){
                    modifiedSearchFilter = {
                        ...(search ? search : {}),
                        created: {
                            start: defaultDateFilterRef.current?.start_date.toISOString(),
                            end: defaultDateFilterRef.current?.end_date.toISOString()
                        }
                    }
                }
                formData.append("search", JSON.stringify(modifiedSearchFilter))

                formData.append("page", params.id)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                // formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append('outlet_id', getOutletId());
                formData.append('brand_id', getBrandId());
                GetOrdersList(formData).then(data => {
                    setDataLength(data.data.response.count);
                    setOrderListData(data && data.data && data.data.response ? data.data.response.rows : [])
                    setLoader(false)
                }).catch(error => {
                    console.log("error ====> ", error);
                })
            }, LOADER_TIME);
        } else {
            // getAllOrders().then(data => {
            //     console.log('-------indexedDB orders, data');
            //     setDataLength(data.length);
            //     setOrderListData(data && data.length ? data : []);
            //     setLoader(false)
            // }).catch(error => {
            //     console.log(error);
            // })
        }
    }, [location, sorting, search, globalSearch, statsUpdate, isBrandChanged, isOutletChanged, newOrder, defaultDateFilter])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])

    // On company panel reload, fetch the outlet's current business date once (it can change from other panels)
    useEffect(() => {
        if (!isOnline()) return;
        GetBrandOutletsList({ brand_ids: JSON.stringify([getBrandId()]) }).then(data => {
            const outlets = data?.data?.response || [];
            const currentOutlet = outlets.find(o => Number(o.id) === Number(getOutletId()));
            if (currentOutlet?.business_date) {
                localStorage.setItem('outlet_business_date', currentOutlet.business_date);
                const start_date = new Date(new Date(currentOutlet.business_date).setHours(0, 0, 0, 0));
                const end_date = new Date(new Date(currentOutlet.business_date).setHours(23, 59, 59, 999));
                defaultDateFilterRef.current = { start_date, end_date };
                // don't clobber the picker if we restored a persisted date filter
                if (!saved?.search?.created) {
                    setDefaultDateFilter([start_date, end_date]);
                }
            }
        }).catch(error => {
            console.log("business date error ====> ", error);
        });
    }, []);

    useEffect(() => {
        let current_outlet_id = localStorage.getItem("outlet_id");

        const handleSocket= async (response)=>{
            console.log('===========> getting socket event', response);

            if (response) {
                if (response?.event === SOCKET_EVENTS.ORDER_CREATED) {
                    if (Number(response?.data?.outlet_id) === Number(current_outlet_id)) {
                        // setOrderListData(prevOrderListData => [response?.data?.order_created_data, ...prevOrderListData])
                        setOrderListData(prevOrderListData => {

                            const orderAlreadyExistsIndex = prevOrderListData.findIndex(order => order.id == response?.data?.order_id);
                            
                            if(orderAlreadyExistsIndex != -1){
                                if(!prevOrderListData[orderAlreadyExistsIndex].zatca_details && response?.data?.order_created_data?.zatca_details){
                                    prevOrderListData[orderAlreadyExistsIndex] = {
                                        ...prevOrderListData[orderAlreadyExistsIndex],
                                        transaction: {
                                            ...prevOrderListData[orderAlreadyExistsIndex].transaction, 
                                            payment_status: response?.data?.order_created_data?.transaction?.payment_status,
                                            payment_method:  response?.data?.order_created_data?.transaction?.payment_method,
                                            tender_id: response?.data?.order_created_data?.transaction?.tender_id,
                                            tender_configuration: {name: response?.data?.order_created_data?.transaction?.tender_name}
                                        },
                                        order_status: response?.data?.order_created_data?.order_status,
                                        zatca_details: response?.data?.order_created_data?.zatca_details
                                    }
                                }
                                return [...prevOrderListData];
                            }

                            setDataLength(prevDataLength => prevDataLength + 1);
                            if(prevOrderListData.length == itemPerPage){
                                prevOrderListData.pop();
                            }
                            const newOrderData = response?.data?.order_created_data;
                            const normalizedOrder = newOrderData?.transaction && !newOrderData.transaction.tender_configuration
                                ? {
                                    ...newOrderData,
                                    transaction: {
                                        ...newOrderData.transaction,
                                        tender_configuration: { name: newOrderData.transaction.tender_name }
                                    }
                                }
                                : newOrderData;
                            return [normalizedOrder, ...prevOrderListData];
                        })
                        // setNewOrder(!newOrder);
                    }
                }else if (response?.event === SOCKET_EVENTS.ORDER_MARKED_READY) {
                    if (Number(response?.data?.outlet_id) === Number(current_outlet_id)) {
                        setOrderListData(prevOrderListData =>{
                            const updatedOrderListData = prevOrderListData.map(order =>{
                                return order.id == response?.data?.order_id 
                                ? { ...order, order_status : response?.data?.order_status }
                                : order
                            })
                            return updatedOrderListData;
                        })
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: `Order with id : ${response?.data?.order_id} is ${response?.data?.order_status} now`,
                            showConfirmButton: false,
                            timer: 4000,
                            toast: true,
                            position: 'top-right',
                        })
                        // setNewOrder(!newOrder);
                    }
                }else if (response?.event === SOCKET_EVENTS.ORDER_MARKED_CLOSE) {
                    if (Number(response?.data?.outlet_id) === Number(current_outlet_id)) {
                        setOrderListData(prevOrderListData =>{
                            const updatedOrderListData = prevOrderListData.map(order =>{
                                return order.id == response?.data?.order_id 
                                ? { ...order, order_status : response?.data?.order_status }
                                : order
                            })
                            return updatedOrderListData;
                        })
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: `Order with id : ${response?.data?.order_id} is ${response?.data?.order_status} now`,
                            showConfirmButton: false,
                            timer: 4000,
                            toast: true,
                            position: 'top-right',
                        })
                        // setNewOrder(!newOrder);
                    }
                }else if (response?.event === SOCKET_EVENTS.ORDER_UPDATED) {
                    if (Number(response?.data?.outlet_id) === Number(current_outlet_id)) {
                        
                        if(response?.data?.update_type == 'cancel-order'){
                            setOrderListData(prevOrderListData => prevOrderListData.filter(order => order.id != response?.data?.order_id))

                            // If we cancelled this order locally, the API-response toast is
                            // already shown — consume the flag and skip this socket toast.
                            if(suppressCancelToastRef.current){
                                suppressCancelToastRef.current = false;
                            }else{
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    position: 'absolute',
                                    icon: 'info',
                                    title: response?.message,
                                    showConfirmButton: false,
                                    timer: 4000,
                                    toast: true,
                                    position: 'top-right',
                                })
                            }
                        }else{
                            setOrderListData(prevOrderListData =>{
                                const updatedOrderListData = prevOrderListData.map(order =>{
                                    if(order.id == response?.data?.order_id ){
                                        if(response?.data?.update_type == 'recall-order' || response?.data?.update_type == 'checkout-order'){
                                            return { 
                                                ...order, 
                                                transaction: {
                                                    ...order.transaction, 
                                                    payment_status: response?.data?.payment_status,
                                                    payment_method:  response?.data?.payment_method,
                                                    tender_id: response?.data?.tender_id,
                                                    tender_configuration: {name: response?.data?.tender_name}
                                                },
                                                ...(response?.data?.net_amount ? {net_amount: response?.data?.net_amount}: {}),
                                                ...(response?.data?.tax_total_price ? {tax_total_price: response?.data?.tax_total_price}: {}), 
                                                order_status: response?.data?.order_status, 
                                                zatca_details: response?.data?.zatca_details,
                                            }
                                        }else{
                                            return { 
                                                ...order, 
                                                transaction: {
                                                    ...order.transaction, 
                                                    payment_status: 'refunded',
                                                },
                                                order_status: response?.data?.order_status 
                                            }
                                        }
                                    }
                                    return order;
                                })
                                return updatedOrderListData;
                            })
                            Swal.fire({
                                customClass: 'swal-wide',
                                position: 'absolute',
                                icon: 'success',
                                title: `Order with id : ${response?.data?.order_id} is updated`,
                                showConfirmButton: false,
                                timer: 4000,
                                toast: true,
                                position: 'top-right',
                            })
                        }
                    }
                }else if (response?.event === SOCKET_EVENTS.REQUEST_ANSWERED) {
                    if (response?.data?.outlet_id === Number(current_outlet_id)) {
                        if ([REQUEST_SLUGS.REFUND, REQUEST_SLUGS.COUPON, REQUEST_SLUGS.PROMO].includes(response?.data?.slug)) {
                            Swal.fire({
                                customClass: 'swal-wide',
                                position: 'absolute',
                                icon: response?.data?.status == 1 ? 'success' : 'error',
                                // title: `order refund request is accepted for ${response?.data?.order_id}`,
                                title : response.message,
                                showConfirmButton: false,
                                timer: 4000,
                                toast: true,
                                position: 'top-right',
                            })
                        }
                    }
                }
            }
        }

        SOCKET_CLIENT.on('GET-DATA', handleSocket);

        // ✅ Clean up on unmount to prevent duplicate listeners
        return () => {
            SOCKET_CLIENT.off("GET-DATA", handleSocket);
        };
    }, [orderListData])

    // console.log(orderListData, '------orderListData');
    
    // search or filter function
    const prepareSearch = (key, value) => {
        console.log("preparing search", key, value)
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }
    // search or filer end

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        setSelectedOrderMode('');
        setSelectedOrderStatus('');
        setSelectedTransactionType('');
        setSelectedZatcaStatus('');
        setSelectedPaymentStatus('');
        setDefaultDateFilter([defaultDateFilterRef.current.start_date, defaultDateFilterRef.current.end_date])
        clear()
        console.log("Filters reset");
        // $("#defaultstatus").prop("selectedIndex", 0)
    }


    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }
    const viewFunction = (id) => {
        navigate(`/company/transaction/order/view/${id}?pageno=${page}`);
    };

    const printFunction = async (id) => {
        setGlobalLoader(true);
        try {
            const brand_id = getBrandId();
            const [orderRes, invoiceRes] = await Promise.all([
                GetSingleOrderDetails({ id, brand_id }),
                GetCustomerInvoice({ brand_id }).catch(() => null),
            ]);
            const orderDetails = orderRes?.data?.response;
            if (!orderDetails) {
                throw new Error('Order details not found');
            }
            const invoiceSettings = invoiceRes?.data?.response || {};
            const canvas = await renderReceiptCanvas(orderDetails, invoiceSettings);
            invoiceCanvasRef.current = canvas;
            setInvoicePreview({ open: true, image: canvas.toDataURL('image/png'), order: orderDetails });
            setGlobalLoader(false);
        } catch (error) {
            setGlobalLoader(false);
            console.log('Generate invoice error ====> ', error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.message || 'Could not generate the invoice.',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }
    };

    const handleDownloadInvoice = () => {
        if (invoiceCanvasRef.current) {
            canvasToPdf(invoiceCanvasRef.current, invoicePreview.order);
        }
    };

    useEffect(() => {
        AllRefundReasons({ brand_id: getBrandId() })
            .then((data) => {
                setAllRefundReasons(data && data?.data && data?.data?.response ? data?.data?.response : [])
            })
            .catch((error) => {
                console.log("errors===>", error)
            })
    }, []);

    const handleRefundSubmit = (orderId) => {
        if (refundReasonText.length > 250) {
            setError('Reason cannot exceed 250 characters');
            return;
        }
        // Implement your refund logic here
        const formData = new FormData()
        formData.append("id", refundOrderId || orderId)
        formData.append("refund_reason_id", refundReason);
        if (refundReason === 'other') {
            formData.append("refund_reason", refundReasonText);
        }
        formData.append("payment_status", "refunded");
        RefundStatus(formData).then(response => {
            setShowRefundModal(false);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            })
            setRefundReason('')
            setRefundReasonText('')
            setStatusUpdate(!statsUpdate)
        }).catch(error => {
            console.log("error ====> ", error);
        })

    };

    const recallOrder = (order) => {
        const data = {
            recallOrderId: order.id, 
            aggregator_id: order.aggregator_id,
            order_mode_id: order.order_mode_id,
            order_mode_name: order.order_mode_configuration.name,
            surcharge: Number(order.surcharge_price),
            surcharge_tax_amount: Number(order.surcharge_tax_amount),
            tax_type: order.tax_type
        }
        navigate(`/company/transaction/order/add`, { state: data });
    }
    const checkoutOrder = (orderId) => {
        navigate(`/company/transaction/order/continueOrder?orderId=${orderId}`);
    }
    // useEffect(()=>{
    //     handleRefundSubmit();
    // },[])

    const ChangeStatus = (row, Num) => {
        // const formData = new FormData()
        // formData.append("id", row)
        // formData.append("status", Num)
        // Swal.fire({
        //     customClass: 'swal-wide',
        //     title: 'Are you sure?',
        //     icon: 'warning',
        //     showCancelButton: true,
        //     confirmButtonColor: '#403fad',
        //     cancelButtonColor: '#f1388b',
        //     confirmButtonText: 'Yes'
        // }).then((result) => {
        //     if (result.isConfirmed) {
        //         ChangeStatusLoyaltyPoint(formData).then(data => {
        //             if (data.status === 200) {
        //                 Swal.fire({
        //                     customClass: 'swal-wide',
        //                     position: 'absolute',
        //                     icon: 'success',
        //                     title: data.data.message,
        //                     showConfirmButton: false,
        //                     timer: 2000,
        //                     toast: true,
        //                     position: 'top-right',
        //                 })
        //                 setStatusUpdate(!statsUpdate)
        //             }
        //         }).catch(error => {
        //             console.log("error===>")
        //         })
        //     }
        // })
    }
    useEffect(() => {
        GetActiveOrderModes(getBrandId()).then(data => {
            setOrderModesData(data && data.data && data.data.response ? data.data.response : []);
        }).catch(error => {
            console.log("error=====>", error);
        });
    }, []);
    // useEffect(() => {
    //     GetOutletAllList(getCompany().company_id).then(data => {
    //         setOutletFilterData(data && data.data && data.data.response ? data.data.response : []);
    //     }).catch(error => {
    //         console.log("error=====>", error);
    //     });
    // }, []);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        console.log('filter changed------>', name, value)
        if (name === 'order-status') {
            setSelectedOrderStatus(value);
            prepareSearch("order_status", value);
        } else if (name === 'transaction_type') {
            setSelectedTransactionType(value);
            prepareSearch("transaction_type", value);
        } else if (name === 'zatca_status') {
            setSelectedZatcaStatus(value);
            prepareSearch("zatca_status", value);
        } else if (name === 'payment_status') {
            setSelectedPaymentStatus(value);
            prepareSearch("payment_status", value);
        } else {
            setSelectedOrderMode(value);
            prepareSearch("order_mode_id", value);
        }
    };

    const headerMapping = {
        "order_id": "Order ID",
        "order_mode": "Order Mode",
        "aggregator_name": "Aggregator",
        "aggregator_external_id": "Aggregator Id",
        "ordered_by": "Ordered By",
        // "outlet_name": "Outlet Name",
        // "location": "Outlet Location",
        "customer_name": "Customer Name",
        "customer_number": "Customer Number",
        // "customer_address": "Customer Address",
        "created_at": "Created At",
        "total_price": "Total Price",
        "total_price_with_tax": "Total Price With Tax",
        // "discount_price": "Discount Price",
        "payment_type": "Payment Type",
        "payment_method": "Payment Method",
        "payment_status": "Payment Status",
        "order_status": "Order Status",
        // "refund_reason": "Refund Reason",
        "menu_item": "Menu Item Name",
        "add_on": "Menu Item Add On",
        "business_date": "Business Date"
    };
    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('outlet_id', getOutletId());

        ExportOrdersList(formData).then(data => {
            const exportData = data && data.data && data.data.response ? data.data.response.rows : [];
            
            const printData = exportData.map((item) => {
                const transformedItem = {};
                // Extract fields from nested objects
                const orderID = item?.id || 'N/A';
                const customerName = item.customer?.customer_name || 'N/A';
                const customerNumber = item.customer?.customer_number || 'N/A';
                const customerAddress = item.customer?.customer_address || 'N/A';
                const outlet = item.outlet?.outlet_name || 'N/A';
                const location = item.outlet?.location || 'N/A';
                const createdAt = new Date(item?.created_at).toLocaleString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                }).replace(',', '')
                const totalPrice = Number(item?.net_amount) - Number(item?.tax_total_price);
                const totalPriceWithTax = item?.net_amount || '0';
                const orderStatus = item?.order_status || 'N/A';
                const discountPrice = item?.discount_price || '0';
                const paymentType = capitalizeFirstLetter(item?.transaction?.payment_method) || 'N/A';
                const paymentMethod = capitalizeFirstLetter(item?.transaction?.tender_configuration?.name) || 'N/A';
                // const paymentMethod = capitalizeFirstLetter(item?.transaction?.tender_name) || 'N/A';
                const paymentStatus = capitalizeFirstLetter(item?.transaction?.payment_status) || 'N/A';
                const refundReason = capitalizeFirstLetter(item?.transaction?.refund_reason) || 'N/A';
                const orderMode = capitalizeFirstLetter(item?.order_mode_configuration?.name) || 'N/A';

                // Map fields according to headerMapping
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "order_id":
                                transformedItem[newKey] = orderID;
                                break;
                            case "order_mode":
                                transformedItem[newKey] = orderMode;
                                break;
                            case "aggregator_name":
                                transformedItem[newKey] = item.aggregators_configuration?.name;
                                break;
                            case "aggregator_external_id":
                                transformedItem[newKey] = item.aggregator_external_id || "N/A";
                                break;
                            case "ordered_by":
                                transformedItem[newKey] = item.order_source == 'online' ? 'Online' : `${item.user?.first_name} ${item.user?.last_name}`;
                                break;
                            case "outlet_name":
                                transformedItem[newKey] = capitalizeFirstLetter(outlet);
                                break;
                            case "location":
                                transformedItem[newKey] = capitalizeFirstLetter(location);
                                break;
                            case "customer_name":
                                transformedItem[newKey] = capitalizeFirstLetter(customerName);
                                break;
                            case "customer_number":
                                transformedItem[newKey] = customerNumber;
                                break;
                            case "customer_address":
                                transformedItem[newKey] = capitalizeFirstLetter(customerAddress);
                                break;
                            case "created_at":
                                transformedItem[newKey] = createdAt;
                                break;
                            case "total_price":
                                transformedItem[newKey] = totalPrice;
                                break;
                            case "total_price_with_tax":
                                transformedItem[newKey] = totalPriceWithTax;
                                break;
                            case "discount_price":
                                transformedItem[newKey] = discountPrice;
                                break;
                            case "payment_type":
                                transformedItem[newKey] = paymentType;
                                break;    
                            case "payment_method":
                                transformedItem[newKey] = paymentMethod;
                                break;
                            case "payment_status":
                                transformedItem[newKey] = paymentStatus;
                                break;
                            case "order_status":
                                transformedItem[newKey] = capitalizeFirstLetter(orderStatus);
                                break;
                            case "refund_reason":
                                transformedItem[newKey] = (refundReason);
                                break;
                            case "business_date":
                                transformedItem[newKey] = formateDate(item.business_date);
                                break;
                            case "menu_item":
                                transformedItem[newKey] = 'See separate sheet';
                                break;
                            case "add_on":
                                transformedItem[newKey] = 'See separate sheet';
                                break;
                            default:
                                // Handle any unexpected keys
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const menuItemsData = exportData.flatMap(item => {
                const ID = item?.id || 'N/A';
                const Name = item.customer?.customer_name || 'N/A';
                return (item.customer_order_menu_item_relations || []).map(data => ({
                    'Order ID': ID,
                    'Customer Name': Name,
                    'Menu Items': capitalizeFirstLetter(data?.menu_item?.item_name || 'N/A'),
                    'Quantity': (data?.quantity || 'N/A'),
                }));
            });
            // const addOnData = exportData.flatMap(item => {
            //     const ID = item?.id || 'N/A';
            //     const Name = item.customer?.customer_name || 'N/A';
            //     return (item.customer_order_add_on_relations || []).map(data => ({
            //         'Order ID': ID,
            //         'Customer Name': Name,
            //         'Menu Item Name': capitalizeFirstLetter(data?.menu_item?.item_name || 'N/A'),
            //         'Menu Item Add On': capitalizeFirstLetter(data?.menu_add_on?.name || 'N/A'),
            //         'Add On Price': (parseInt(data?.menu_add_on?.price) + " SAR" || '0 SAR'),
            //         'Quantity': data?.quantity || 'N/A'
            //     }));
            // });
            const ws1 = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws1['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const ws2 = XLSX.utils.json_to_sheet(menuItemsData, { header: ['Order ID', 'Customer Name', 'Menu Items', 'Quantity'] });
            ws2['!cols'] = getExcelColumnWidths(menuItemsData, ['Order ID', 'Customer Name', 'Menu Items', 'Quantity']);
            // const ws3 = XLSX.utils.json_to_sheet(addOnData, { header: ['Order ID', 'Customer Name', 'Menu Item Name', 'Menu Item Add On', 'Add On Price', 'Quantity'] });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws1, 'Orders');
            XLSX.utils.book_append_sheet(wb, ws2, 'Menu Items');
            // XLSX.utils.book_append_sheet(wb, ws3, 'Menu Item Add On');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'orders.xlsx');
            setGlobalLoader(false);
        }).catch(error => {
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };

    function getLocation(data) {
        if (data.location) {
            return data.location;
        } else if (data.city_id) {
            return data.city_id.name;
        } else {
            return data.state_id.name;
        }
    }

    const createOrder = () => {
        navigate(`/company/transaction/order/order-mode`);
        // UpdateDateOfBusiness({ outlet_id : getOutletId() }).then(response => {
        //     navigate(`/company/transaction/order/order-mode`)
        // }).catch(error => {
        //     console.log("error ====> ", error);
        // })
    }

    const generateOrderId = (orderId) => {
        let id = orderId;
        let countOfDigits = 0;
        while (id) {
            id = Math.floor(id / 10);
            countOfDigits += 1;
        }

        if (countOfDigits >= 4) {
            return orderId
        }
        let zerosCount = 4 - countOfDigits;
        let generatedZeros = '';
        while (zerosCount) {
            generatedZeros += '0';
            zerosCount -= 1;
        }
        return `${generatedZeros}${orderId}`;
    }


    const reportToZatca = (orderID) => {
        setLoaderNew(true);
        try {
            let formData = new FormData();
            formData.append("order_id", orderID);
            formData.append("report_type", 'paid');
            reportToZatcaAgain(formData)
                .then((response) => {
                    console.log("respone", response)
                    if (response?.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: response?.data?.statuscode == 400 ? 'error' : 'success',
                            title: response?.data?.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        });
                        setLoaderNew(false);
                    }
                    else {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'error',
                            title: response?.data?.message || "Unable to send to the zatca",
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        });
                        setLoaderNew(false);
                    }
                    setStatusUpdate(!statsUpdate)
                })
                .catch((err) => {
                    console.error("Error in API call:", err);
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: err?.response?.data?.errors?.message || err.message || "Unable to send to the zatca",
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true,
                        position: 'top-right',
                    });
                    setLoaderNew(false);
                });
        } catch (error) {
            console.error("Unexpected error:", error);
            setLoaderNew(false);
        }
    };

    function CopytoClipboard(text) {
        // Copy the text inside the text field
        navigator?.clipboard?.writeText(text);
        Swal.fire({
            customClass: 'swal-wide',
            icon: 'success',
            title: 'Copied to clipboard',
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            position: 'top-right',
        });
    }

    const refundOrder = (order)=>{
        setRefundOrderId(order?.id);
        if(!order.area_manager_request){
            setShowRefundModal(true); 
        }else{
            handleRefundSubmit(order?.id);
        }
    }

    const handleForceOrderClose = (orderId)=>{
        setLoaderNew(true);
        
        let formData = new FormData();
        formData.append("id", orderId);
        forceOrderClose(formData)
            .then((response) => {
                if (response?.status === 200) {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: response?.data?.statuscode == 400 ? 'error' : 'success',
                        title: response?.data?.message,
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true,
                        position: 'top-right',
                    });
                    setLoaderNew(false);
                }else {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: response?.data?.message || "Internal server error",
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true,
                        position: 'top-right',
                    });
                    setLoaderNew(false);
                }
                setStatusUpdate(!statsUpdate)
            })
            .catch((err) => {
                console.error("Error in API call:", err);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: err?.response?.data?.errors?.message || "Internal server error",
                    showConfirmButton: false,
                    timer: 2000,
                    toast: true,
                    position: 'top-right',
                });
                setLoaderNew(false);
            });
    }

    const handleCancelOrder = (orderId) => {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: 'Do you want to cancel this order?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#403fad',
            cancelButtonColor: '#f1388b',
            confirmButtonText: 'Yes, cancel order'
        }).then((result) => {
            if (!result.isConfirmed) return;
            setLoaderNew(true);
            suppressCancelToastRef.current = true;
            // Safety net: if the cancel-order socket event never arrives, clear the flag
            // so it can't wrongly suppress a future socket toast.
            setTimeout(() => { suppressCancelToastRef.current = false; }, 15000);
            let formData = new FormData();
            formData.append("id", orderId);
            DeletePendingOrder(formData)
                .then((response) => {
                    if (response?.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: response?.data?.statuscode == 400 ? 'error' : 'success',
                            title: response?.data?.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        });
                    } else {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'error',
                            title: response?.data?.message || "Internal server error",
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        });
                    }
                    setLoaderNew(false);
                    setStatusUpdate(!statsUpdate)
                })
                .catch((err) => {
                    console.error("Error in API call:", err);
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: err?.response?.data?.errors?.message || "Internal server error",
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true,
                        position: 'top-right',
                    });
                    setLoaderNew(false);
                    suppressCancelToastRef.current = false;
                });
        });
    }

    // const createDummyOrders = ()=>{
    //     if(!dummyOrdersCount)return;
        
    //     setLoader(true);
    //     createDummyOrdersForCompany({dummy_orders_count: dummyOrdersCount || 10})
    //     .then(response => {
    //         setLoader(false);
    //         if (response.data.status === 1 || response.data.status === "1") {
    //             setDummyOrdersCount("");
    //             setStatusUpdate(!statsUpdate);
    //             Swal.fire({
    //             customClass: 'swal-wide',
    //             icon: 'success',
    //             title: response.data.message,
    //             showConfirmButton: false,
    //             timer: 1500,
    //             toast: true,
    //             position: 'top-right',
    //             });
    //         } else {
    //             Swal.fire({
    //             customClass: 'swal-wide',
    //             icon: 'error',
    //             title: response.data.message,
    //             showConfirmButton: false,
    //             timer: 5000,
    //             toast: true,
    //             position: 'top-right',
    //             })
    //         }
    //     })
    //     .catch(error => {
    //         console.log("error ====> ", error);
    //     })
    // }

    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Orders</h4>
                    </div>

                    <div className='page-header-right ms-auto d-flex'>
                    

                        {/* <div className="col-lg-6 form-group d-flex align-items-center me-3">
                            <label htmlFor="printer_ip" className="fw-medium me-2 mb-0" style={{ width: "120px" }}>Create dummy orders</label>
                            <input name="printer_ip[]" id="printer_ip" placeholder='Enter orders count' type="number" min={1} max={1000}  className="form-control" autoComplete="off"
                                value={dummyOrdersCount}
                                onChange={(e)=> {setDummyOrdersCount(e.target.value > 0 ? e.target.value : "")}} 
                            />
                            
                            <button className="btn btn-secondary ms-2" onClick={createDummyOrders}> Create dummy orders</button>
                        </div> */}
                        

                        <button className="btn btn-primary ms-2" onClick={handleExport} disabled={dataLength === 0}>Export Orders</button>

                        {
                            checkPermission('store_orders', 'add') 
                            ? <button className="btn btn-primary ms-2" onClick={() => { createOrder() }}>Create Order</button>
                            : ''
                        }
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search here" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="">
                                    <div className="form-group mb-0 filter_icon_container filter_design">
                                        <div className="">
                                            <select
                                                name='order-mode'
                                                placeholder="order-mode"
                                                className={`form-control cp `} style={{ width: "auto" }}
                                                onChange={handleFilterChange}
                                                value={selectedOrderMode}
                                                id="resetFilter"
                                            >
                                                <option value=''>Order Mode</option>
                                                {orderModeData.map((mode, index) => (
                                                    <option key={index} value={mode.id}>
                                                        {mode.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                    </div>
                                </div>
                                <div className="">
                                    <div className="form-group mb-0 filter_icon_container filter_design">
                                        <div className="">
                                            <select
                                                name='order-status'
                                                placeholder="Order Status"
                                                className={`form-control cp `} style={{ width: "auto" }}
                                                onChange={handleFilterChange}
                                                value={selectedOrderStatus}

                                                id="resetFilter"
                                            >
                                                <option value=''>Order Status</option>
                                                <option value="pending">Pending</option>
                                                <option value="in_kitchen">In Kitchen</option>
                                                <option value="ready">Ready</option>
                                                <option value="closed">Closed</option>
                                                <option value="refunded">Refunded</option>
                                            </select>
                                        </div>


                                    </div>
                                </div>
                                <div className="">
                                    <div className="form-group mb-0 filter_icon_container filter_design">
                                        <div className="">
                                            <select
                                                name='payment_status'
                                                placeholder="Payment Status"
                                                className={`form-control cp `} style={{ width: "auto" }}
                                                onChange={handleFilterChange}
                                                value={selectedPaymentStatus}
                                                id="resetFilter"
                                            >
                                                <option value=''>Payment Status</option>
                                                <option value="pending">Pending</option>
                                                <option value="paid">Paid</option>
                                                <option value="refunded">Refunded</option>
                                            </select>
                                        </div>


                                    </div>
                                </div>
                                <div className="">
                                    <div className="form-group mb-0 filter_icon_container filter_design">
                                        <div className="">
                                            <select
                                                name='transaction_type'
                                                placeholder="Transactions"
                                                className={`form-control cp `} style={{ width: "auto" }}
                                                onChange={handleFilterChange}
                                                value={selectedTransactionType}
                                                id="resetFilter"
                                            >
                                                <option value=''>Transaction</option>

                                                <option value="cash">Cash</option>
                                                <option value="card">Card</option>
                                                <option value="credit">Credit</option>
                                                <option value="online">Online</option>
                                            </select>
                                        </div>


                                    </div>
                                </div>

                                  <div className="">
                                    <div className="form-group mb-0 filter_icon_container filter_design">
                                        <div className="">
                                            <select
                                                name='zatca_status'
                                                placeholder="Zatca Status"
                                                className={`form-control cp `} style={{ width: "auto" }}
                                                onChange={handleFilterChange}
                                                value={selectedZatcaStatus}
                                                id="resetFilter"
                                            >
                                                <option value=''>Zatca Status</option>
                                                <option value="synced">Synced</option>
                                                <option value="unsynced">Un-synced</option>
                                            </select>
                                        </div>


                                    </div>
                                </div>
                                {/* <div className="">
                                    <div className="form-group mb-0 filter_icon_container filter_design">
                                        <div className="">
                                           <select
                                                placeholder="Outlet name"
                                                className={`form-control cp `}
                                                onChange={handleFilterChange}
                                                id="resetFilter"
                                            >
                                                {outletFilterData &&
                                                    outletFilterData.length > 0 &&
                                                    outletFilterData.map((option, i) => {
                                                        return (
                                                            <option key={i} value={option?.id}>
                                                                {capitalizeFirstLetter(option?.name)}
                                                            </option>
                                                        );
                                                    })}
                                            </select> 
                                        </div>


                                    </div>
                                </div> */}
                                <div className="date-input">
                                    {/* <CustomRangepicker currentDateDefault={currentDateDefault} GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} /> */}
                                    <CustomRangepicker defaultDateFilter={defaultDateFilter} GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                {/* <StatusFilter data={showFilterlist} prepareSearch={prepareSearch} value={search.status === undefined ? '' : String(search.status)} /> */}
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                {loaderNew && (
                                    <div className="loader-overlay">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <thead>
                                    <tr>
                                        <th style={{ width: '8%' }}>
                                            <div className='sorting_column'>
                                                <span>Order Id</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th style={{ width: '9%' }} className='action_head'>Order Mode</th>
                                        <th style={{ width: '9%' }} className='action_head'>Aggregator Name</th>
                                        <th style={{ width: '5%' }} className='action_head'>Aggregator ID</th>
                                        <th style={{ width: '9%' }} className='action_head'>Ordered By</th>
                                        <th style={{ width: '9%' }}>
                                            <div className='sorting_column'>
                                                <span>Customer</span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="first_name" /> */}
                                            </div>
                                        </th>
                                        <th style={{ width: '8%' }}>
                                            <div className='sorting_column'>
                                                <span>Contact</span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="first_name" /> */}
                                            </div>
                                        </th>
                                        {/* <th style={{ width: '10%' }}>
                                            <div className='sorting_column'>
                                                <span>Outlet Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="email" />
                                            </div>
                                        </th> */}
                                        {/* <th style={{ width: '10%' }}>
                                            <div className='sorting_column'>
                                                <span>Outlet Location</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="brandname" />
                                            </div>
                                        </th> */}
                                        <th style={{ width: '12%' }} className="created_head">
                                            <div className='sorting_column'>
                                                <span>Created At</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        
                                        <th style={{ width: '7%' }} className=''>Total Price</th>
                                        <th style={{ width: '7%' }} className=''>Total Price With Tax</th>
                                        <th style={{ width: '10%' }} className='action_head'>Payment Method</th>
                                        <th style={{ width: '8%' }} className='action_head'>Payment Status</th>
                                        <th style={{ width: '10%' }} className='action_head'>Status</th>
                                        <th style={{ width: '12%' }} className="created_head">
                                            <div>
                                                <span>Business Date</span>
                                            </div>
                                        </th>
                                        <th style={{ width: '8%' }} className='action_head'>Zatca Status</th>
                                        <th style={{ width: '10%' }} className='action_head text-end'>Action</th>
                                    </tr>
                                </thead>

                            
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={16}><Loader /></td>
                                        </tr> :
                                        <>
                                            {orderListData.length > 0 ? (
                                                orderListData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{`#order ${generateOrderId(row?.id)}`}</td>
                                                        <td className=''>{capitalizeFirstLetter(row?.order_mode_configuration?.name)}</td>
                                                        <td className=''>{row?.aggregators_configuration?.name ? capitalizeFirstLetter(row?.aggregators_configuration?.name) : "N/A"}</td>
                                                        <td className=''>{row?.aggregator_external_id ? (row?.aggregator_external_id) : "N/A"}</td>
                                                        <td >
                                                            {   
                                                                row?.order_source == 'online'
                                                                ? 'Online'
                                                                : (row?.user ? `${capitalizeFirstLetter(row?.user?.first_name)} ${capitalizeFirstLetter(row?.user?.last_name)}` : "N/A")
                                                            }
                                                        </td>
                                                        <td >{capitalizeFirstLetter(row?.customer_name)}</td>
                                                        <td >{row?.customer?.customer_number ? row?.customer?.customer_number : "-"}</td>
                                                        <td >
                                                            {new Date(row?.created_at).toLocaleString('en-GB', {
                                                                day: '2-digit',
                                                                month: '2-digit',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true,
                                                            }).replace(',', '')}
                                                        </td>
                                                        

                                                         <td className=' ' >{showPrice(Number(row?.net_amount) - Number(row?.tax_total_price))} SAR</td>
                                                        <td className=' ' >{showPrice(Number(row?.net_amount))} SAR</td>
                                                        <td className=''>{row?.transaction?.tender_configuration?.name ? capitalizeFirstLetter(row?.transaction?.tender_configuration?.name) : '-'}</td>
                                                        <td className=''>{capitalizeFirstLetter(row?.transaction?.payment_status)}</td>
                                                        <td className=''>
                                                            {row.order_status == "in_kitchen" ? "In kitchen" : capitalizeFirstLetter(row.order_status)}
                                                        </td>
                                                        <td>{row?.business_date ? formateDate(row?.business_date) : 'N/A' }</td>
                                                        <td className=''>
                                                            {
                                                                !row?.zatca_details
                                                                    ? <span className='text-danger'>False</span>
                                                                    : row?.zatca_details?.success === false
                                                                        ? <button className="btn btn-danger btn-sm" onClick={() => { setShowZatcaDetailsModel(true); setZatcaModelData(row) }}>Error</button>
                                                                        : <button className="btn btn-primary btn-sm" onClick={() => { setShowZatcaDetailsModel(true); setZatcaModelData(row) }}>Cleared</button>
                                                            }
                                                        </td>
                                                        <td className='text-end'>
                                                            <div className="dropdown d-inline-block">
                                                                <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className='ti ti-dots-vertical'></i>
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    {checkPermission('store_orders', 'view') ?
                                                                        <li>
                                                                            <div className='dropdown-item' onClick={() => { viewFunction(row?.id) }}>
                                                                                <i className="ti ti-eye" aria-hidden="true"></i> View details
                                                                            </div>
                                                                        </li>
                                                                        : ''}
                                                                    <li>
                                                                        <div className='dropdown-item' onClick={() => { printFunction(row.id) }}>
                                                                            <i className="ti ti-printer" aria-hidden="true"></i> Print
                                                                        </div>
                                                                    </li>
                                                                    {
                                                                        // refunds only for orders of the outlet's current business day
                                                                        row?.transaction?.payment_status == 'paid' && checkPermission('store_refund', 'add') && isOutletBusinessDay(row?.business_date) ?
                                                                            <li>
                                                                                <div className='dropdown-item' onClick={() => { refundOrder(row) }}>
                                                                                    <i className="ti ti-receipt-refund sidemenu-icon"></i> 
                                                                                    {row?.area_manager_request ? 'Check Refund Status' : 'Refund'}
                                                                                </div>
                                                                            </li>
                                                                            : null
                                                                    }
                                                                    {
                                                                        row?.transaction?.payment_status == 'pending' ?
                                                                            <li>
                                                                                <div className='dropdown-item' onClick={() => { recallOrder(row); }}>
                                                                                    <i className="ti ti-receipt-refund sidemenu-icon"></i> Recall order
                                                                                </div>
                                                                            </li> : null
                                                                    }
                                                                    {
                                                                        row?.transaction?.payment_status == 'pending' ?
                                                                            <li>
                                                                                <div className='dropdown-item' onClick={() => { checkoutOrder(row?.id); }}>
                                                                                    <i className="ti ti-receipt-refund sidemenu-icon"></i> Checkout Order
                                                                                </div>
                                                                            </li> : null
                                                                    }
                                                                    {
                                                                        !row?.zatca_details || row?.zatca_details?.success === false ?
                                                                            <li>
                                                                                <div className='dropdown-item' onClick={() => { reportToZatca(row?.id) }}>
                                                                                    <i className="ti ti-receipt-refund sidemenu-icon"></i> Report To zatca again
                                                                                </div>
                                                                            </li> : null
                                                                    }
                                                                    {   
                                                                        (companyUser?.platform_user_role?.slug=='company_admin' || companyUser?.platform_user_role?.slug=='system_admin') &&
                                                                        (row?.transaction?.payment_status == 'paid' || row?.transaction?.payment_status == 'refunded')  
                                                                        && row?.order_status != 'closed' && row?.order_status != 'refunded' ?
                                                                            <li>
                                                                                <div className='dropdown-item' onClick={() => { handleForceOrderClose(row.id) }}>
                                                                                    <i className="ti ti-receipt-refund sidemenu-icon"></i> 
                                                                                    Force Close 
                                                                                </div>
                                                                            </li>
                                                                            : null
                                                                    }
                                                                    {
                                                                        // An unpaid order can be cancelled whatever its order status.
                                                                        row?.transaction?.payment_status == 'pending' ?
                                                                            <li>
                                                                                <div className='dropdown-item' onClick={() => { handleCancelOrder(row?.id) }}>
                                                                                    <i className="ti ti-trash sidemenu-icon"></i> Cancel Order
                                                                                </div>
                                                                            </li> : null
                                                                    }
                                                                </ul>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={16} className="text-center">
                                                        <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                        <p>No record found</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "order", path: "/company/transaction/order/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={invoicePreview.open} onHide={() => setInvoicePreview({ open: false, image: '', order: null })} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Invoice Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ textAlign: 'center', maxHeight: '70vh', overflowY: 'auto', background: '#e9ecef' }}>
                    {invoicePreview.image &&
                        <img
                            src={invoicePreview.image}
                            alt="Invoice preview"
                            style={{ width: '300px', maxWidth: '100%', background: '#fff', boxShadow: '0 0 8px rgba(0,0,0,0.25)' }}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setInvoicePreview({ open: false, image: '', order: null })}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleDownloadInvoice}>
                        <i className="ti ti-download me-1" aria-hidden="true"></i> Download PDF
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showRefundModal} onHide={() => { setShowRefundModal(false); setRefundReason(''); setRefundReasonText(''); }}>
                <Modal.Header closeButton>
                    <Modal.Title>Refund Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="refundReason" className='mb-3'>
                            <Form.Label>Select reason to refund order</Form.Label>
                            <div className='cp select-down-arrow'>
                                <Form.Control
                                    className=''
                                    as="select"
                                    rows={3}
                                    value={refundReason}
                                    onChange={(e) => setRefundReason(e.target.value)}
                                    placeholder="Select reason"
                                >
                                    <option value="">Select a reason</option>
                                    {allRefundReasons?.map((reason) => (
                                        <option key={reason.id} value={reason.id}>
                                            {reason.reason}
                                        </option>
                                    ))}
                                </Form.Control>
                            </div>
                            {/* {error && <small className="text-danger">{error}</small>} */}
                        </Form.Group>
                        {refundReason === 'other' &&
                            <Form.Group controlId="refundReasonText">
                                <Form.Label>Enter reason to refund order</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={refundReasonText}
                                    onChange={(e) => setRefundReasonText(e.target.value)}
                                    placeholder="Enter reason"
                                />
                                {error && <small className="text-danger">{error}</small>}
                            </Form.Group>
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-primary" onClick={() => { setShowRefundModal(false); setRefundReason(''); setRefundReasonText('') }} >
                        Close
                    </button>
                    <Button variant="primary" onClick={handleRefundSubmit} disabled={!refundReason || (refundReason === 'other' && !refundReasonText)}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                size="lg"
                show={showZatcaDetailsModel}
                onHide={() => setShowZatcaDetailsModel(false)}
                backdrop={true}
                className="modal-height-auto"
            >
                <Modal.Header className="text-white">
                    <Modal.Title>{zatcaModelData?.zatca_details?.success === false ? 'ZATCA Error Details' : 'ZATCA Details'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container overflow-auto" style={{ maxHeight: "70vh" }}>
                        {zatcaModelData?.zatca_details?.success === false ? (
                            <>
                                {/* Error Header */}
                                <div className="mb-4">
                                    <h3 className="fw-bold text-danger">ZATCA Error Details</h3>
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Order Date:</strong>{" "}
                                                <span className="text-secondary">{formateDate(zatcaModelData?.zatca_details?.order_created_at || zatcaModelData?.created_at)}</span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Transaction Date:</strong>{" "}
                                                <span className="text-secondary">{formateDate(zatcaModelData?.zatca_details?.order_transaction_at || zatcaModelData?.transaction?.created_at)}</span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>HTTP Status:</strong>{" "}
                                                <span className="text-danger">{zatcaModelData?.zatca_details?.status || 'N/A'}</span>
                                            </p>
                                        </div>
                                        {/* <div className="col-md-4">
                                            <p>
                                                <strong>ZATCA Status:</strong>{" "}
                                                <span className="text-danger">{zatcaModelData?.zatca_details?.message?.status || 'ERROR'}</span>
                                            </p>
                                        </div> */}
                                    </div>
                                </div>
                                <hr className="my-4" />
                                {/* Error Messages */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">Error Messages</h3>
                                    {zatcaModelData?.zatca_details?.message?.errorMessages?.length > 0 ? (
                                        zatcaModelData.zatca_details.message.errorMessages.map((err, i) => (
                                            <div key={i} className="bg-light border border-danger rounded p-3 mb-3">
                                                <div className="row g-2">
                                                    <div className="col-md-6">
                                                        <p className="mb-1"><strong>Code:</strong> <span className="text-danger">{err.code || 'N/A'}</span></p>
                                                        <p className="mb-1"><strong>Type:</strong> <span className="text-secondary">{err.type || 'N/A'}</span></p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p className="mb-1"><strong>Status:</strong> <span className="text-danger">{err.status || 'N/A'}</span></p>
                                                        <p className="mb-1"><strong>Category:</strong> <span className="text-secondary">{err.category || 'N/A'}</span></p>
                                                    </div>
                                                    <div className="col-12">
                                                        <p className="mb-0"><strong>Message:</strong> <span className="text-secondary">{err.message || 'N/A'}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-secondary">No error messages available.</p>
                                    )}
                                </div>
                                {/* Warning Messages */}
                                {zatcaModelData?.zatca_details?.message?.warningMessages?.length > 0 && (
                                    <>
                                        <hr className="my-4" />
                                        <div className="mb-4">
                                            <h3 className="fw-bold">Warning Messages</h3>
                                            {zatcaModelData.zatca_details.message.warningMessages.map((warn, i) => (
                                                <div key={i} className="bg-light border border-warning rounded p-3 mb-3">
                                                    <p className="mb-1"><strong>Code:</strong> <span className="text-warning">{warn.code || 'N/A'}</span></p>
                                                    <p className="mb-1"><strong>Category:</strong> <span className="text-secondary">{warn.category || 'N/A'}</span></p>
                                                    <p className="mb-0"><strong>Message:</strong> <span className="text-secondary">{warn.message || 'N/A'}</span></p>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                                {/* Info Messages */}
                                {zatcaModelData?.zatca_details?.message?.infoMessages?.length > 0 && (
                                    <>
                                        <hr className="my-4" />
                                        <div className="mb-4">
                                            <h3 className="fw-bold">Info Messages</h3>
                                            {zatcaModelData.zatca_details.message.infoMessages.map((info, i) => (
                                                <div key={i} className="bg-light border rounded p-3 mb-3">
                                                    <p className="mb-1"><strong>Code:</strong> <span className="text-secondary">{info.code || 'N/A'}</span></p>
                                                    <p className="mb-0"><strong>Message:</strong> <span className="text-secondary">{info.message || 'N/A'}</span></p>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                {/* Header Details */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">Header Details</h3>
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Order Date:</strong>{" "}
                                                <span className="text-secondary">
                                                    {formateDate(zatcaModelData?.zatca_details?.order_created_at)}
                                                </span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Transaction Date:</strong>{" "}
                                                <span className="text-secondary">
                                                    {formateDate(zatcaModelData?.zatca_details?.order_transaction_at)}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-4" />

                                {/* Document Type and Status */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">Document Type & Status</h3>
                                    <p>
                                        <strong>Document Type:</strong>{" "}
                                        <span className="text-secondary">Sales Invoice</span>
                                    </p>
                                    <p>
                                        <strong>ZATCA Status:</strong>{" "}
                                        <span className="text-secondary">Cleared</span>
                                    </p>
                                </div>
                                <hr className="my-4" />

                                {/* QR Code and Validation Results */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">QR Code & Validation Results</h3>
                                    <div className="row g-4 align-items-center">
                                        <div className="col-md-6">
                                            <h5 className="fw-semibold">Validation Results</h5>
                                            <div
                                                className="bg-light p-3 rounded shadow-sm h-100 d-flex flex-column justify-content-center"
                                                style={{ minHeight: "200px" }}
                                            >
                                                <p>
                                                    <strong>Status:</strong>{" "}
                                                    <span className="text-secondary">202 Accepted</span>
                                                </p>
                                                <p>
                                                    <strong>Validation Result:</strong>{" "}
                                                    <span className="text-secondary">Accepted</span>
                                                </p>
                                                <p>
                                                    <strong>InfoMessages:</strong>{" "}
                                                    <span className="text-secondary">
                                                        {zatcaModelData?.zatca_details?.validation_results?.infoMessages?.[0]?.message || "N/A"}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6 text-center">
                                            <h5 className="fw-semibold">QR Code</h5>
                                            <div
                                                className="bg-light p-4 rounded shadow-sm h-100 d-flex justify-content-center align-items-center"
                                                style={{ minHeight: "200px" }}
                                            >
                                                <QRCode
                                                    size={256}
                                                    style={{ height: "auto", maxWidth: "50%", width: "50%" }}
                                                    value={zatcaModelData?.zatca_details?.qr || 'Sample Qr'}
                                                    viewBox={`0 0 256 256`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* QR Code */}
                                <div className="mb-4">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h3 className="fw-bold text-dark">QR Code</h3>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-main-primary ripple ms-3"
                                            onClick={() => { CopytoClipboard(zatcaModelData?.zatca_details?.qr) }}
                                        >
                                            <i className="fa fa-clone" aria-hidden="true"></i>
                                            <span className="d-none d-sm-inline"> Copy</span>
                                        </button>
                                    </div>
                                    <div className="row g-4 align-items-center">
                                        <div className="col-md-12 text-center">
                                            <div className="bg-light p-4 rounded shadow-sm h-100 d-flex justify-content-center align-items-center" style={{ minHeight: "150" }}>
                                                <textarea
                                                    className="form-control"
                                                    rows={20}
                                                    style={{ width: "100%", minHeight: "200px", resize: "vertical" }}
                                                    value={zatcaModelData?.zatca_details?.qr || ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Invoice XML */}
                                <div className="mb-4">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h3 className="fw-bold text-dark">Invoice XML</h3>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-main-primary ripple ms-3"
                                            onClick={() => { CopytoClipboard(zatcaModelData?.zatca_details?.invoice_xml) }}
                                        >
                                            <i className="fa fa-clone" aria-hidden="true"></i>
                                            <span className="d-none d-sm-inline"> Copy</span>
                                        </button>
                                    </div>
                                    <div className="row g-4 align-items-center">
                                        <div className="col-md-12 text-center">
                                            <div className="bg-light p-4 rounded shadow-sm h-100 d-flex justify-content-center align-items-center" style={{ minHeight: "250" }}>
                                                <textarea
                                                    className="form-control"
                                                    rows={20}
                                                    style={{ width: "100%", minHeight: "300px", resize: "vertical" }}
                                                    value={zatcaModelData?.zatca_details?.invoice_xml || ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowZatcaDetailsModel(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

}

export default RefundOrder